import { config } from '../../../../config'

export const ATLAS_SERVER_URL = config.get('ATLAS_SERVER_URL')!
